import { render } from "./SwiperNavigationComponent.vue?vue&type=template&id=8d3c7770&ts=true"
import script from "./SwiperNavigationComponent.vue?vue&type=script&lang=ts"
export * from "./SwiperNavigationComponent.vue?vue&type=script&lang=ts"

import "./SwiperNavigationComponent.vue?vue&type=style&index=0&id=8d3c7770&lang=postcss"
/* custom blocks */
import block0 from "./SwiperNavigationComponent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/var/www/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__